import { Amplify } from "aws-amplify";
import { resetPassword, confirmResetPassword } from "@aws-amplify/auth";

export interface CognitoInitOptions {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
}

export function initCognitoAuth(opts: CognitoInitOptions): void {
  Amplify.configure({
    Auth: {
      region: opts.region,
      Cognito: {
        userPoolId: opts.userPoolId,
        userPoolClientId: opts.userPoolClientId,
      },
    } as any,
  });
}

export async function triggerForgotPassword(username: string): Promise<void> {
  await resetPassword({ username });
}

export async function confirmForgotPassword(
  username: string,
  code: string,
  newPassword: string
): Promise<void> {
  await confirmResetPassword({
    username,
    confirmationCode: code,
    newPassword,
  });
}
